import { useEffect, useState } from "react";
import { BasePageContainer } from "../../components/common";
import CustomLoader from "../../components/common/CustomLoader";
import Common360Table from "./components/common/Common360Table";
import { getDashboardData } from "../../service/ai-model.service";
import { DashboardViewType } from "../../helper/constant";
import { useAppContext } from "../../context/app.context";

const Customer360Page = () => {

  const [tableData, setTableData] = useState({ schema: null, data: [] });
  const [loading, setLoading] = useState(true);
  const { activeDashboardVersion } = useAppContext();

  useEffect(() => {
    if (activeDashboardVersion) {
      setLoading(true);
      const org = new URLSearchParams(window.location.search).get('org');
      getDashboardData({ type: DashboardViewType.CUSTOMERS, org, versionId: activeDashboardVersion }).then(response => {
        if (response) {
          let { schema, data } = response;
          setTableData({ schema, data });
        }
      }).catch(error => {
        console.error("Error fetching supplier data:", error);
      }).finally(() => setLoading(false))
    }
  }, [activeDashboardVersion]);

  const renderBusinessTable = () => {
    if (tableData.schema && tableData.data.length > 0) {
      return <Common360Table
        sections={tableData.schema}
        suppliers={tableData.data}
        title={'360Business.AI Customers'}
        styles={{ background: 'linear-gradient(90deg, #439F66, #9C9C64' }} />
    }
    return <h4 className="d-flex flex-column align-items-center justify-content-center h-100vh" >No data available</h4>
  }

  return (
    <div className="row mx-0 loginwrap">
      <BasePageContainer>
        {loading && <CustomLoader full />}
        {renderBusinessTable()}
      </BasePageContainer>
    </div>
  );
};

export default Customer360Page;
